export default {
    name: 'soilType',
    serverName: '​/api/v1/soil_type/soil_type/',
    apiUrl: '/api/v1/soil_type/soil_type/'
};
